
    <div class="social-links">
        <div *ngFor="let item of socialItemList">
            <a [attr.href]="item.link" target="_blank" [ngClass]="item.name | lowercase" [textContent]="item.name"></a>
        </div>
    </div>